import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setArticlesPosts, setTopics } from "../redux/articles-posts.slice";
import { useArticlePosts } from "../hooks/useArticlePosts";
import { useTopics } from "../hooks/useTopics";

const StaticQueriesWrapper = ({ children }) => {
    const dispatch = useDispatch();
    const articlePosts = useArticlePosts();
    const topics = useTopics();

    useEffect(() => {
        dispatch(setArticlesPosts(articlePosts));
        dispatch(setTopics(topics));
    }, [dispatch, articlePosts, topics]);

    return children;
};

export default StaticQueriesWrapper;
